import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#080808',
        color: '#ffffff',
        fontFamily: "'Instrument Sans', sans-serif"
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  return user ? children : <Navigate to="/signin" />;
};

export default ProtectedRoute;